import React, { useState } from "react";
import { Route } from "react-router-dom";
import "./App.scss";
import Starter from "./Components/LargeViewPorts/MainPage/Starter";
import MenuList from "./Components/SmallViewPorts/MenuList";
import { UserContext } from "./Components/UserContext";
import TopMenu from "./Components/LargeViewPorts/Menu/TopMenu";
function App() {
  const [value, setValue] = useState(true);
  return (
    <>
      <UserContext.Provider value={{ value, setValue }}>
        <Route exact path="/" component={Starter} />
        <Route exact path="/a" component={MenuList} />
        <Route exact path="/t" component={TopMenu} />
      </UserContext.Provider>
    </>
  );
}

export default App;
